import { KEY_VALUE_TYPE } from './currency_type';

export const COUNTRY_CODE_MAP: KEY_VALUE_TYPE = {
    us: 'en-us',
    ca: 'en-ca',
    uk: 'en-uk',
    eu: 'en-eu',
    za: 'en-za',
    au: 'en-au',
    de: 'de-de',
    fr: 'fr-fr',
    es: 'es-es',
    it: 'it-it',
    jp: 'ja-jp',
    kr: 'ko-kr',
    cn: 'zh-cn',
    ru: 'ru-ru',
    cis: 'ru-ru',
    nl: 'nl-nl',
    tw: 'zh-tw',
    sa: 'sa',
    br: 'pt-br',
};

export const COUNTY_CURRENCY_MAP: KEY_VALUE_TYPE = {
    us: 'USD',
    ca: 'CAD',
    uk: 'GBP',
    eu: 'EUR',
    za: 'ZAR',
    au: 'AUD',
    de: 'EUR',
    fr: 'EUR',
    es: 'EUR',
    it: 'EUR',
    jp: 'JPY',
    kr: 'KRW',
    cn: 'CNY',
    ru: 'RUB',
    cis: 'RUB',
    nl: 'NZD',
    tw: 'TWD',
    sa: 'SAR',
    br: 'BRL',
};

export const formatCountryCurrency = (amount: number | string, locale: string) => {
    if (Number(amount) === 0 && amount !== 0 && amount !== '0') {
        return null;
    }
    const countryCode = COUNTRY_CODE_MAP[locale] || COUNTRY_CODE_MAP['us'];
    const countryCurrency = COUNTY_CURRENCY_MAP[locale] || COUNTY_CURRENCY_MAP['us'];
    try {
        return new Intl.NumberFormat(countryCode, {
            style: 'currency',
            currency: countryCurrency,
        }).format(Number(amount) || 0);
    } catch (e) {
        console.error(e);
    }
    return null;
};
